const comparePos = <T extends { pos: number }>(a: T, b: T) => a.pos - b.pos;

export default comparePos;
